export default __webpack_public_path__ + "static/media/ELEMENTOS_17.0d6686f3.png";